export default "__VITE_ASSET__CcF7yX63__ 208w";